<div class="ui segment" id="wrapper">
  <div class="sub-header" appMargin marginB="5">Invoices</div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
  </div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  >
  </app-search-filter>

  <!-- </div> -->
  <div
    fxLayout="row"
    appMargin
    class="ui segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    id="dark"
  >
    <div fxFlex="5%">
      <sui-checkbox> </sui-checkbox>
    </div>
    <div fxFlex="20">INVOICE NO.</div>
    <div fxFlex="40">SERVICE TYPE</div>
    <div fxFlex="20">INVOICE AMOUNT</div>
    <div fxFlex="15">OUTSTANDING AMOUNT</div>
    <div fxFlex="10">NO. OF PAYMENT</div>
    <div fxFlex="15">STATUS</div>
    <div fxFlex="15%"></div>
  </div>

  <div
    class="ui basic segment"
    appPadding
    paddingX="0"
    paddingY="0"
    [ngClass]="{ loading: pending }"
  >
    <app-invoice-row
      [department]="s"
      *ngFor="let s of invoices"
      (onView)="viewDepartment($event)"
      (onDownload)="download($event)"
    ></app-invoice-row>

    <app-no-record-found
      *ngIf="invoices && invoices.length < 1"
    ></app-no-record-found>
  </div>
  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui labeled button">
          <div class="ui tiny icon button" (click)="getPage(1)">
            <i class="refresh icon"></i>
          </div>
          <a class="ui basic label"> {{ totalItems }} Record(s) </a>
        </div>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="mini"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>
